// ---------------------------------------------------------------------------
// WelcomeScreen — tela inicial da view Documentation V3.
//
// Em vez de abrir direto no primeiro topico, o usuario chega numa tela de
// boas-vindas que explica, em linguagem simples (sem jargao tecnico):
//   1. Objetivo da tela.
//   2. Como o conteudo e gerado (IA + revisao da equipe Integration).
//   3. Como usar a documentacao.
//   4. Que tambem existe o "Assistente IA" (botao na lateral direita).
//
// Vive dentro do `contentCard` (mesmo fundo cinza claro do conteudo) e
// reaproveita o scroll fino do app (`useOverlayScrollStyles`).
// ---------------------------------------------------------------------------

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import {
  TrackChanges,
  Stars,
  MenuBook,
  QuestionAnswer,
} from "@material-ui/icons";

import documentationV3Style from "../../../assets/jss/material-dashboard-pro-react/views/documentationV3Style";
import { useOverlayScrollStyles } from "../inputs_v3_components";

const useStyles = makeStyles(documentationV3Style);

export default function WelcomeScreen() {
  const classes = useStyles();
  const { t } = useTranslation();
  const overlayScrollClasses = useOverlayScrollStyles();

  const cards = [
    {
      key: "objective",
      Icon: TrackChanges,
      title: t("modeling_documentation.welcome_card_objective_title"),
      text: t("modeling_documentation.welcome_card_objective_text"),
    },
    {
      key: "generation",
      Icon: Stars,
      title: t("modeling_documentation.welcome_card_generation_title"),
      text: t("modeling_documentation.welcome_card_generation_text"),
    },
    {
      key: "usage",
      Icon: MenuBook,
      title: t("modeling_documentation.welcome_card_usage_title"),
      text: t("modeling_documentation.welcome_card_usage_text"),
    },
    {
      key: "assistant",
      Icon: QuestionAnswer,
      title: t("modeling_documentation.welcome_card_assistant_title"),
      text: t("modeling_documentation.welcome_card_assistant_text"),
    },
  ];

  return (
    <div
      className={cx(classes.contentScroll, overlayScrollClasses.overlayScroll)}
    >
      <div className={classes.welcome}>
        <div className={classes.welcomeHero}>
          <h1 className={classes.welcomeTitle}>
            {t("modeling_documentation.welcome_title")}
          </h1>
        </div>

        <div className={classes.welcomeCards}>
          {cards.map(({ key, Icon, title, text }) => (
            <div key={key} className={classes.welcomeCard}>
              <div className={classes.welcomeCardIcon}>
                <Icon fontSize="inherit" />
              </div>
              <div className={classes.welcomeCardTitle}>{title}</div>
              <div className={classes.welcomeCardText}>{text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
